import { Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import TabPanel from "../../components/TabPanel";
import EmailTemplatesList from "./EmailTemplatesList";
import MsgTemplatesList from "./SmsTemplatesList";

export default function EmailTemplates() {
  const [tabValue, setTabValue] = useState(0);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <>
      <Tabs value={tabValue} onChange={handleChange} aria-label="tabs">
        <Tab label="Email Templates" />
        <Tab label="Sms Templates" />
      </Tabs>
      <TabPanel value={tabValue} index={0}>
        <EmailTemplatesList />
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <MsgTemplatesList />
      </TabPanel>
    </>
  );
}
